import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class DeleteVehicleTypeImgCommand extends IRequestCommand<
    ICommandResponse,
    ErrorDetails,
    IDeleteVehicleTypeImgCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/{transportTypeId}/deleteImg/{imgId}';
  public override setParameters(parameters: IDeleteVehicleTypeImgCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{transportTypeId}',
      parameters.transportTypeId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{imgId}',
      parameters.imgId.toString()
    );
  }
}

export interface IDeleteVehicleTypeImgCommandParameters extends ICommandParameters {
    carrierId: string;
    transportTypeId: number;
    imgId: number;
}
